import React from 'react';
import { Form, Card, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import PhoneInput, { PhoneNumber } from 'antd-phone-input';

interface PhoneStepProps {
  phone: string;
  loading: boolean;
  error: string | null;
  onPhoneChange: (phone: string) => void;
  onClearError: () => void;
}

const PhoneStep: React.FC<PhoneStepProps> = ({
  phone,
  loading,
  error,
  onPhoneChange,
  onClearError
}) => {
  const { t } = useTranslation();

  const validator = (_: any, { valid }: any) => {
    if (valid()) return Promise.resolve();
    return Promise.reject(t('phone-number-incorrect', { ns: 'validations' }));
  };

  const handlePhoneChange = (value: PhoneNumber) => {
    if (error) onClearError();
    
    if (!value.countryCode || !value.phoneNumber) {
      return;
    }
    onPhoneChange('+' + value.countryCode + value.areaCode + value.phoneNumber);
  };

  return (
    <Card>
      <Row justify="center">
        <Col xs={24} sm={18} md={14} lg={10} xl={8}>
          <Form layout="vertical" disabled={loading}>
            <Form.Item
              label={t('telegram-form-phone-number', { ns: 'standard' })}
              name="phone"
              rules={[{ validator }]}
              validateStatus={error ? 'error' : ''}
              help={error ? t(error, { ns: 'errors' }) : ''}
            >
              <PhoneInput
                enableSearch
                value={phone}
                onChange={handlePhoneChange}
                style={{ maxWidth: '100%' }}
              />
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </Card>
  );
};

export default PhoneStep;
